import { useSelector } from "react-redux";

import messages from "../../../../../assets/locale/messages";
import CompanyInfoSection from "../components/CompanyInfoSection";
import ViewUploadedFile from "../../../../../components/Upload/FileUpload/ViewUploadedFile";

const BankTransferRequest = () => {
  const lang = useSelector((state) => state.locale.lang);
  const {
    businessVerification: {
      requestDetails: { bankTransfer }
    }
  } = messages[lang];

  const requestDetails = useSelector(
    (state) =>
      state.businessVerification
        .bankTransferVerificationRequestDetails
  );

  return (
    <div className="bank-transfer-request-details">
      <div className="white-bg border-radius-10 p-4 mb-3">
        <CompanyInfoSection />
        <div className="transcript-section pt-4 ">
          <p className="title-color- fsize-13">
            {bankTransfer.bankTransferTranscript}
          </p>
          <ViewUploadedFile
            file={requestDetails?.DefaultDocument}
            name={requestDetails?.OriginlDefaultDocumentName}
            type={
              requestDetails?.OriginlDefaultDocumentName?.includes(
                "pdf"
              )
                ? "pdf"
                : "image"
            }
            isFileLink
            viewMode
          />
        </div>
      </div>
    </div>
  );
};

export default BankTransferRequest;
